'use client'

import Image from 'next/image'

import { ImageApiResponse } from '@/lib/api-connector-strapi-cms/api/components/Image.types'
import { Marquee } from '@/lib/ui-kit/components/ui/Marquee.component'

interface CarouselProps {
  badges: ImageApiResponse[]
  apiAssetsUrl?: string
}

export const BadgeMarquee = ({ badges, apiAssetsUrl }: CarouselProps) => {
  return (
    <Marquee direction="left" numberOfCopies={5} fade>
      {badges.map((badge, index) => (
        <Image
          key={index}
          className="mx-2 h-[8rem] w-auto xl:h-[15.625rem]"
          src={`${apiAssetsUrl || ''}${badge.url}`}
          width={badge.width}
          height={badge.height}
          alt={badge.alternativeText || 'Badge'}
        />
      ))}
    </Marquee>
  )
}
